import React from "react";
import DDMLOGO from "../DDMLOGO.png";
import "../App.css";
const Logo=()=>{
  return (
    <div className="logo">
      <img src={DDMLOGO} alt="logo" className="logo" />
    </div>

  )
};
export default Logo;